module.exports = __webpack_public_path__ + "img/pi-2-4-1.42df9dc0.jpg";